module.exports = __webpack_public_path__ + "static/img/teseImg1.4e551df6.jpg";